import React from 'react';
import MoonLoader from "react-spinners/MoonLoader";


const Spinner = (props: any) => {

    const spinnerStyle = {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height:"200px"
    };

    const defaultSize = 60;

    return (
        <div style={spinnerStyle} className={props.className? props.className : '' } >
            <MoonLoader color="#26556e"  size={props.size?  props.size : defaultSize}/>
        </div>
    )
};

export default Spinner;